/** @internal */
export type PromiseOrValue<T> = Promise<T> | T;
